import script from "./BaseTab2.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTab2.vue?vue&type=script&setup=true&lang=js"

import "./BaseTab2.vue?vue&type=style&index=0&id=5a77b4aa&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a77b4aa"]])

export default __exports__